import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { accessibility,formStyles,grid } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { EventManager } from '../../utilities/events';
import { cache } from 'lit/directives/cache.js';
import { ContextConsumer } from '@lit/context';
import { organisationContext } from '../../utilities/context';
import { arrowBack } from '../../utilities/icons';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
export class AllInMembersManager extends AllInSessionStorage(AllInOrganisationConsumer(LitElement)) {
    static properties = {
        currentOrg: {type: String, reflect:true},
        _events: { state:true,type: Array },
        _currentPage: { state:true,type: Number },

    }

    constructor() {
        super();
        this._currentPage = 1;
    }

    async connectedCallback() {
        super.connectedCallback();
        this.eventManager.listen(`allin-organisation-members-page`,(e)=>{this.currentPage = e.detail.page;});
        this.organisationData = this._organisationData?.value;
        if(!this.currentOrg){
            return;
        }
        if(!this.organisation){
            this.organisation = this._getOrganisationById(this.currentOrg);
        }
        
        if(this.organisation && !this.members?.[this.currentOrg]){
            await this._fetchMembers(this._currentPage);
        }
        if(this.panel){
            let memberDetails = this.panel.split('__');
            let memberId = memberDetails[0];
            let memberSurname = memberDetails[1];
            let member = this._getMemberById(memberId);
            if(!member){
                
                if(memberId && memberSurname){
                    await this._fetchMember(memberId,memberSurname);
                }
            }
            this._showPanel(this.panel,this.view);
        }
        this.renderRoot.querySelector('button,a')?.focus();
    }
    
    disconnectedCallback(){
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    async updated(changedProperties){
        if(changedProperties.has('currentOrg')){
            this.organisation = this._getOrganisationById(this.currentOrg);
            if(this.organisation && !this.members?.[this.currentOrg]){
                await this._fetchMembers(this._currentPage);
            }
        }
        if(changedProperties.has('panel')||changedProperties.has('view')){
            this.renderRoot.querySelector('button,a')?.focus();
            if(this.panel&&this.panel!=this.prevPanel){
                let memberDetails = this.panel.split('__');
                let memberId = memberDetails[0];
                let memberSurname = memberDetails[1];
                let member = this._getMemberById(memberId);
                if(!member){ 
                    if(memberId && memberSurname){
                        await this._fetchMember(memberId,memberSurname);
                    }
                }
                this._showPanel(this.panel,this.view);
            }
        }
        if(changedProperties.has('currentPage')){
            if(this._currentPage&&!this.members?.[this.currentOrg]?.[`page_${this._currentPage}`]){
                this._fetchMembers(this._currentPage);
            }
        }
    }

    render() {
        let main='';
        let button = html`<button class="back" @click=${this._hidePanel}><span aria-hidden="true">${arrowBack}</span>${msg(str`Return to all members`)}</button>`;
        if(this.panel){
            let memberDetails = this.panel.split('__');
            let memberId = memberDetails[0];
            let memberSurname = memberDetails[1];
            let member = this._getMemberById(memberId);
            
            if(!member){
               main = html`<allin-loader loading></allin-loader>`;
            }
            else{
                main=html`
                    ${button}

                    <allin-member name=${this.name} .member=${member} .restUrl=${this.restUrl} .nonce=${this.nonce}></allin-member>
                `;
            }
        }
        else{
            main=html`
                <allin-organisation-members name=${this.name} page=${this._currentPage}></allin-organisation-members>
            `;
        }
        return html`${main}`;
    }

    async _showPanel(panel,view){
        let name = '';
        let memberDetails = this.panel.split('__');
        let memberId = memberDetails[0];
        let memberSurname = memberDetails[1];
        let member = this._getMemberById(memberId);
        if(member){
            name = `${member.firstName} ${member.lastName} member profile`;
        }
        else{
            name = 'Member';
        }
        if(view){
            panel+=`/${view}`;
        }
        let crumb = {
            organisation:{url:`/organisation-dashboard/${this.currentOrg}/`,title:`${this.organisation?.name}`},
            dashboard:{url:`/organisation-dashboard/${this.currentOrg}/members/`,title:msg(str`Members lookup`)},
            panel:{url:`/organisation-dashboard/${this.currentOrg}/members/${this.panel}/`,title:name}
        }
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
        this.eventManager.addHistory('/organisation-dashboard/'+this.currentOrg+'/members/'+panel,{panel:this.panel});
    }

    _hidePanel(){
        this.panel = '';
        let crumb = {
            organisation:{url:`/organisation-dashboard/${this.currentOrg}/`,title:`${this.organisation?.name}`},
            dashboard:{url:`/organisation-dashboard/${this.currentOrg}/members/`,title:msg(str`Members lookup`)}
        }
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
        this.eventManager.addHistory('/organisation-dashboard/'+this.currentOrg+'/members',{panel:''});
        this.eventManager.emit(`allin-header-${this.name}`,{name:this.name,text:msg(str`${this.organisation?.name} Dashboard`)});
        this._updateContext({panel:'',view:''});
        this.partial = false;
    }

    _getOrganisationById(id){
        return this.organisations.find((org)=>org.org_id==id);
    }
    
    _getMemberById(allInMemberNumber){
        let member = this.members?.[this.currentOrg]?.[allInMemberNumber];
        if(!member){
            member = this.membersLookedUp?.[this.currentOrg]?.[allInMemberNumber];
        }
        return member;
    }

   

    async _fetchMembers(page){
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-members&nonce=${this.nonce}&page=${page}`;
        try{
            let response = await fetch(url,{
                headers: {
                    'AllIn-Nonce': this.nonce, 
                }
            })
            let data = await response.json();
            if(!this.members?.[this.currentOrg]){
                this.members = this.members || {};
                this.members[this.currentOrg] = {};
            }
            this.members[this.currentOrg][`page_${page}`] = data.members.data;
            data.members.data.forEach((member)=>{
                this.members[this.currentOrg][member.allInMemberNumber] = member;
            });
            this.members[this.currentOrg].total = data.members.total;

            this._updateContext({members:this.members});
        }
        catch(error){
            console.error('Error:', error);
        }
    }

    async _fetchMember(allInMemberNumber,surname){
        let url = `${this.restUrl}?action=get_member_by_allin_member_number&nonce=${this.nonce}&member_id=${allInMemberNumber}&member_surname=${surname}`;
        try{
            let response = await fetch(url,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })
            let data = await response.json();
            if(data && !data.error){
                this.membersLookedUp = this.membersLookedUp || {};
                this.membersLookedUp[this.currentOrg] = this.membersLookedUp[this.currentOrg] || {};
                this.membersLookedUp[this.currentOrg][data.allInMemberNumber] = data;
                this._updateContext({membersLookedUp:this.membersLookedUp});
            }
            return data;
        }
        catch(error){
            console.error('Error:', error);
        }
    }

    static styles = [
        accessibility,
        formStyles,
        grid,
        css`
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }

        .grid{
            gap:1.5rem;
        }
        
        .card a{
            display:block;
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            background-color:var(--allin-highlight-color,#472961);
            color:#fff;
            text-align:center;
            font-weight:700;
            text-decoration:none;
            transition:background-color var(--transition) ease;
            height:fit-content;
            align-self:end;
        }

        .card:hover a{
            background-color:var(--allin-highlight-color-lighter,#5e3e7d);
        }


        h3,p{
            margin:0;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child{
            width:40%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:60%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }

        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform:none !important;
            }
        }

        `
        ];
}